var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVisiblePassword = function SvgVisiblePassword(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#343754",
    fillRule: "nonzero",
    d: "M20.429 7c-1.167-1.786-2.763-3.318-4.678-4.29a5.36 5.36 0 0 1 .749 2.734c0 3.002-2.468 5.445-5.5 5.445S5.5 8.446 5.5 5.444c0-.96.258-1.908.749-2.734C4.334 3.682 2.738 5.214 1.57 7c2.1 3.208 5.488 5.444 9.429 5.444 3.94 0 7.33-2.236 9.429-5.444zm-8.84-4.667A.594.594 0 0 0 11 1.75c-2.05 0-3.732 1.665-3.732 3.694 0 .316.27.584.59.584.318 0 .588-.268.588-.584C8.446 4.06 9.6 2.917 11 2.917c.32 0 .59-.268.59-.584zM22 7c0 .304-.098.583-.246.839C19.496 11.52 15.358 14 11 14S2.504 11.509.246 7.839A1.67 1.67 0 0 1 0 7c0-.304.098-.583.246-.839C2.504 2.491 6.642 0 11 0s8.496 2.491 10.754 6.161c.148.256.246.535.246.839z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVisiblePassword, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/visible-password.fca7c099.svg";
export { ForwardRef as ReactComponent };